import React, { useState } from 'react';
import FormLayout from '../components/FormLayout';
import VehicleForm from '../components/VehicleForm';
import { innameFormConfig } from '../config/forms';
import { t } from '../locales/nl';

const InnameForm: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<string>('');

  return (
    <FormLayout 
      title={t.innameFormTitle}
      currentSection={currentSection}
    >
      <VehicleForm 
        formType="inname"
        formConfig={innameFormConfig}
        onSectionChange={setCurrentSection}
      />
    </FormLayout>
  );
};

export default InnameForm;